import { createModal } from "./coreModal.js";

export function openInlineModal({ selector, onOpen }) {
  const modal = createModal({ modifier: "l-modal--inline" });
  if (!modal) return;

  const target = document.querySelector(selector);
  if (!target) return;

  const clone = target.cloneNode(true);
  clone.style.display = "block";
  modal.body.appendChild(clone);
  
  // ★ここでOpen時の処理追加
  if (onOpen) onOpen(clone);

  setupGroupNav(clone, selector, modal.close);
}

function setupGroupNav(clone, selector, close) {
  const triggers = [...document.querySelectorAll('[data-modal-type="inline"]')];
  const current = triggers.find((el) => el.dataset.src === selector);
  const group = current?.dataset.group;
  if (!group) return;

  const groupTriggers = triggers.filter((el) => el.dataset.group === group);
  const index = groupTriggers.indexOf(current);

  const prevBtn = clone.querySelector(".l-inline__nav__btn--prev");
  const nextBtn = clone.querySelector(".l-inline__nav__btn--next");

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      close();
      openInlineModal({
        selector:
          groupTriggers[
            (index - 1 + groupTriggers.length) % groupTriggers.length
          ].dataset.src,
      });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      close();
      openInlineModal({
        selector:
          groupTriggers[(index + 1) % groupTriggers.length].dataset.src,
      });
    });
  }
}
